import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, fmtErr } from "../lib/api";
import { MoonStar } from "lucide-react";

export default function VerificaEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return; // il token è monouso: una sola chiamata
    sentRef.current = true;
    const token = params.get("token") || "";
    if (!token) {
      setState("error");
      setMessage("Link di verifica mancante o non valido.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("error"); setMessage(fmtErr(e, "Link non valido o scaduto.")); });
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="verifica-email-page">
      <div className="mystic-card p-8 sm:p-10 text-center">
        <MoonStar className="w-8 h-8 text-amber-400 mx-auto mb-3" />
        <h1 className="font-display text-3xl text-amber-100 mb-4">Verifica email</h1>
        {state === "loading" && (
          <p className="text-purple-200/70 text-sm" data-testid="verifica-loading">Verifica in corso…</p>
        )}
        {state === "ok" && (
          <div data-testid="verifica-success">
            <p className="text-purple-200/80 text-sm leading-relaxed mb-6">
              La tua email è verificata. Ora puoi iniziare le tue consultazioni con Arcana.
            </p>
            <Link to="/cliente" data-testid="verifica-continua-btn" className="gold-btn inline-block px-8 py-3 text-sm">
              Continua
            </Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verifica-error">
            <p className="text-red-400 text-sm mb-6">{message}</p>
            <Link to="/accedi" data-testid="verifica-login-link" className="text-xs text-amber-300/80 hover:text-amber-200 underline underline-offset-2 transition-colors">
              Accedi per richiedere una nuova email di verifica
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
